import { z } from 'zod';

/**
 * Emitted when an inbound webhook has been persisted (IMM-90 / ADR 0016). The
 * dispatch subscriber loads the row by `webhookId` and hands the payload to the
 * provider parser. Deliberately minimal + pre-tenant-resolution: workspace/member
 * mapping happens in the consuming module, not here.
 */
export const WebhookCreatedPayloadSchema = z.object({
  webhookId: z.uuid(),
  provider: z.string().min(1),
  occurredAt: z.iso.datetime(),
});

export type WebhookCreatedPayload = z.infer<typeof WebhookCreatedPayloadSchema>;
